import axios from "axios";

export function uploadShopifyImageUrl() {
  return `${window.location.origin}/.netlify/functions/upload-shopify-image`;
}

export async function postUploadFunction(payload) {
  try {
    const response = await axios.post(uploadShopifyImageUrl(), payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "upload-shopify-image failed";
    throw new Error(message);
  }
}
